import { FilePermissionAction } from '@rematter/frontend-lib-api-client/grpc/files/v1/file_pb';

export const filePermissionActionLabels: Record<FilePermissionAction, string> =
  {
    [FilePermissionAction.UNSPECIFIED]: 'Unspecified',
    [FilePermissionAction.GRANT]: 'Grant',
    [FilePermissionAction.REVOKE]: 'Revoke',
  };
